{
  "sectionId": "case_manager",
  "header": "Case Manager",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "orgName",
      "fieldName": "orgName",
      "label": "Regional Center",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter an Regional Center.",
      "isAvailable": "Y",
      "placeholder": "Regional Center"
    },
    {
      "attribute_ID": "firstName",
      "fieldName": "firstName",
      "label": "First Name",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter the first name.",
      "isAvailable": "Y",
      "placeholder": "First Name"
    },
    {
      "attribute_ID": "lastName",
      "fieldName": "lastName",
      "label": "Last Name",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter the last name.",
      "isAvailable": "Y",
      "placeholder": "Last Name"
    },
    {
      "attribute_ID": "email",
      "fieldName": "email",
      "label": "Email Address",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter an email address.",
      "isAvailable": "Y",
      "placeholder": "Email Address"
    },
    {
      "attribute_ID": "mobile",
      "fieldName": "mobile",
      "label": "Mobile Number",
      "type": "input",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please enter a mobile number.",
      "isAvailable": "Y",
      "placeholder": "Mobile Number"
    },
    {
      "attribute_ID": "active",
      "fieldName": "active",
      "label": "Is Active",
      "type": "select",
      "mandatory": "Y",
      "validator": null,
      "tooltip": "Please select is active",
      "isAvailable": "Y",
      "placeholder": "Mobile Number"
    },
    {
      "attribute_ID": "ldssCode",
      "fieldName": "ldssCode",
      "label": "LDSS Office",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select LDSS Office",
      "isAvailable": "N",
      "placeholder": "LDSS Office"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": ["firstName"],
          "functionParams": {
            "ErrMsg": "Please enter the first name."
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": ["lastName"],
          "functionParams": {
            "ErrMsg": "Please enter the last name."
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": ["email", "mobile"],
          "functionParams": {
            "minNeeded": 1,
            "ErrMsg": "Please provide a value for at least one of the contact methods"
          }
        },
        {
          "validatorid": 4,
          "attribute_ID": ["orgName"],
          "functionParams": {
            "minNeeded": 1,
            "ErrMsg": "Please enter the Regional Center."
          }
        },
        {
          "validatorid": 5,
          "attribute_ID": ["active"],
          "functionParams": {
            "ErrMsg": "Please select a value"
          }
        }
      ]
    },
    {
      "whatToCheck": "checkFieldValue",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": ["firstName"],
          "functionParams": {
            "isNullAllowed": "N",
            "Format": "^[A-zÀ-ÿ\\s'\\-.]+$",
            "ErrMsg": "Valid characters are A-z, periods (.), hyphens (-), spaces, and apostrophes (')"
          }
        },
        {
          "validatorid": 2,
          "attribute_ID": ["lastName"],
          "functionParams": {
            "isNullAllowed": "N",
            "Format": "^[A-zÀ-ÿ\\s'\\-.]+$",
            "ErrMsg": "Valid characters are A-z, periods (.), hyphens (-), spaces, and apostrophes (')"
          }
        },
        {
          "validatorid": 3,
          "attribute_ID": ["email"],
          "functionParams": {
            "isNullAllowed": "N",
            "Format": "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,3}$",
            "ErrMsg": "Please enter a valid email address."
          }
        },
        {
          "validatorid": 4,
          "attribute_ID": ["mobile"],
          "functionParams": {
            "isNullAllowed": "N",
            "Format": "^\\d{10}$",
            "ErrMsg": "Please enter a mobile number in the format 9999999999."
          }
        }
      ]
    },
    {
      "whatToCheck": "customValidator",
      "clientOrServer": "C",
      "attributes": [
        {
          "validatorid": 1,
          "attribute_ID": [
            "mobile"
          ],
          "functionParams": {
            "validatorFunction": "mobileValidation",
            "ErrMsg": "Please enter a valid 10-digit mobile number."
          }
        },
        {
          "validatorid": 1,
          "attribute_ID": [
            "altPhone"
          ],
          "functionParams": {
            "validatorFunction": "telephoneValidation",
            "ErrMsg": "Please enter a valid 10-digit telephone number."
          }
        }
      ]
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Next",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": [1, 2, 3, 4, 5]
        },
        {
          "checkType": "checkFieldValue",
          "validatorid": [1, 2, 3, 4]
        },
        {
          "checkType": "customValidator",
          "validatorid": [1, 2]
        }
      ]
    }
  ]
}
